import styled from 'styled-components';
import { Button, Modal } from 'antd';
import { Text } from '@/components/Typography';

export const ModalStyled = styled(Modal)`
	.ant-modal-content {
		padding: 30px 0;
		min-width: 400px;
		max-width: 520px;
		border-radius: 30px;
	}
`;

export const Description = styled(Text)`
	display: flex;
	font-size: 25px;
	text-align: center;
`;

export const RoundedButton = styled(Button)`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.2rem 1.5rem;
	font-size: 1rem;
	border-radius: 6px;
`;
